import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { useCallback, useState, forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { useViewportFit } from 'hooks/useViewportFit';
import { LocationOptionList } from '../location_option_list';
import { getLabelText } from '../utils';
const dropdownWrapperCss = "dh25jjs";
const DropdownWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownWrapperCss, props.className)} />;
});
const styledLocationOptionListPullUpCss = "s1hdgmia";
const styledLocationOptionListCss = "sh24jae";
const StyledLocationOptionList = forwardRef((props, ref) => {
  const {
    pullUp
  } = props;
  return <LocationOptionList ref={ref} {...props} className={classNames(styledLocationOptionListCss, {
    [styledLocationOptionListPullUpCss]: pullUp
  }, props.className)} />;
});
const styledButtonCss = "sjnwajo";
const StyledButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(styledButtonCss, props.className)} />);
const iconWrapperCss = "in3wnsg";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const styledTextMutedCss = "s1cdbwea";
const styledTextNoLocationCss = "s16zhxuz";
const styledTextCss = "stjf4lx";
const StyledText = forwardRef((props, ref) => {
  const {
    muted,
    noLocation,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledTextCss, {
    [styledTextMutedCss]: muted,
    [styledTextNoLocationCss]: noLocation
  }, props.className)} />;
});
export const NewLocationSelect = ({
  locationKind,
  onChange,
  onRemove,
  nonWebConferencingKinds,
  webConferencingKinds,
  isDisabled
}) => {
  const {
    ref,
    bottomConflict
  } = useViewportFit({
    bottom: 175
  });
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const [isHovered, setIsHovered] = useState(false);
  const updateSelectedKind = useCallback(value => {
    if (value === locationKind) return;
    if (value === 'no_location') {
      onRemove();
    } else {
      onChange(value);
    }
  }, [onChange, onRemove, locationKind]);
  const ChevronIcon = isExpanded ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />;
  const showChevron = isExpanded || isHovered;
  return <DropdownWrapper>
      <StyledButton aria-expanded={isExpanded} onClick={toggle} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} disabled={isDisabled}>
        {locationKind && <IconWrapper>
            <LocationIcon useNewIcons kind={locationKind} />
          </IconWrapper>}
        <StyledText muted={isDisabled} noLocation={!locationKind}>
          {locationKind ? getLabelText(locationKind) : I18n.t('publisher.event_type_editor.sections.event_details.location.no_location')}
        </StyledText>
        {showChevron && ChevronIcon}
      </StyledButton>
      <Dropdown>
        <StyledLocationOptionList ref={ref} useNewIcons pullUp={bottomConflict} updateSelectedKind={updateSelectedKind} nonWebConferencingKinds={nonWebConferencingKinds} webConferencingKinds={webConferencingKinds} />
      </Dropdown>
    </DropdownWrapper>;
};

require("./new_location_select.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./new_location_select.js");